import React from 'react'
// Components
import Container from './Container'
// Styles
import './Section.scss'

class Section extends React.PureComponent {
  render() {
    const libClassName =
      (this.props.className ? this.props.className : '') +
      (this.props.bgAlt ? ' bg-alt' : '') +
      (this.props.bgColor ? ' bg-' + this.props.bgColor : '') +
      (this.props.bgColor === 'primary' ||
      this.props.bgColor === 'secondary' ||
      this.props.bgColor === 'success' ||
      this.props.bgColor === 'warning' ||
      this.props.bgColor === 'danger' ||
      this.props.bgColor === 'info' ||
      this.props.bgColor === 'dark'
        ? ' text-white'
        : '')
    return (
      <section className={'Section ' + (libClassName ? libClassName : '')} id={this.props.id}>
        <Container fluid={this.props.containerFluid}>{this.props.children}</Container>
      </section>
    )
  }
}

export default Section
